module.exports = __webpack_public_path__ + "assets/fonts/Icon-BIP.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/Icon-BIP.svg
// module id = 522
// module chunks = 0